export default __webpack_public_path__ + "static/media/terminal.1f3347af.svg";